import { useEffect, useState } from "react";

//contexts
import { useSampleContext } from "../../contexts";

//components
import { CardA } from "../ui/Cards";

//react-bootstrap
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

//react-select
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

//lists
import SampleCons from "../../constants/sample";

const WizardSampleInfo = ({ step, steps, changeStep, pageID }) => {
  const { sample, setSample } = useSampleContext();
  const [isDisabled, setIsDisabled] = useState(false);

  //checks if the required fields are filled in
  const validateFields = () => {
    if (!sample?.foodMatrix || !sample?.analyte || !sample?.extractionSolvent) {
      console.log("disabled");
      setIsDisabled(true);
    } else {
      console.log("enabled");
      setIsDisabled(false);
    }
  };

  //triggers the validateFields function whenever the selected values change
  useEffect(() => {
    validateFields();
  }, [sample.foodMatrix, sample.analyte, sample.extractionSolvent]);

  useEffect(() => {
    console.log("sample:", sample);
  }, [sample]);

  if (step !== pageID) {
    return null;
  }

  const handleChange = (e, key) => {
    e === null
      ? setSample({ ...sample, [key]: "" })
      : setSample({ ...sample, [key]: e.value });
  };

  return (
    <CardA
      title='Sample Information'
      subtitle='Choose the sample information from the lists below. This will not impact your final results.'
      steps={steps}
      step={step - 1}
    >
      <Form className='full-height mx-md-4 mt-4'>
        <div className='justify-content-start gap-3 full-height'>
          <div className='d-flex flex-row justify-content-evenly gap-3 flex-wrap flex-md-nowrap'>
            <Form.Group controlId='foodMatrix' className='w-100'>
              <Form.Label className='h6'>
                Food Matrix{" "}
                <small className='text-muted fst-italic'>required</small>
              </Form.Label>
              <CreatableSelect
                isClearable
                as='select'
                onChange={(e) => handleChange(e, "foodMatrix")}
                options={SampleCons.FOOD_MATRIX}
                defaultValue={SampleCons.FOOD_MATRIX.find(
                  (item) => item.value === sample.foodMatrix
                )}
                placeholder='Select or type a custom input...'
              />
            </Form.Group>
            <Form.Group controlId='analyte' className='w-100'>
              <Form.Label className='h6'>
                Analyte*{" "}
                <small className='text-muted fst-italic'>required</small>
              </Form.Label>
              <CreatableSelect
                isClearable
                as='select'
                onChange={(e) => handleChange(e, "analyte")}
                options={SampleCons.ANALYTE}
                defaultValue={SampleCons.ANALYTE.find(
                  (item) => item.value === sample.analyte
                )}
                placeholder='Select or type a custom input...'
              />
              <small className='text-muted'>
                *Only analytes listed in the dropdown are supported for
                autodection
              </small>
            </Form.Group>
            <Form.Group controlId='extractionSolvent' className='w-100'>
              <Form.Label className='h6'>
                Extraction Solvent{" "}
                <small className='text-muted fst-italic'>required</small>
              </Form.Label>
              <CreatableSelect
                isClearable
                as='select'
                onChange={(e) => handleChange(e, "extractionSolvent")}
                options={SampleCons.EXTRACTION_SOLVENT}
                defaultValue={SampleCons.EXTRACTION_SOLVENT.find(
                  (item) => item.value === sample.extractionSolvent
                )}
                placeholder='Select or type a custom input...'
              />
            </Form.Group>
          </div>
          <div className='d-flex flex-row justify-content-between'>
            <Form.Group controlId='notes' className='w-100'>
              <Form.Label className='h6'>Notes</Form.Label>
              <Form.Control
                as='textarea'
                rows={6}
                value={sample.notes}
                onChange={(e) => handleChange(e.target, "notes")}
                placeholder='Add any notes here...'
              />
            </Form.Group>
          </div>
        </div>
      </Form>
      <div className='row mt-4 align-content-center'>
        <span className='col-6 d-flex justify-content-center'>
          <button
            type='button'
            className='btn btn-secondary mx-auto w-75'
            onClick={() => changeStep("back")}
          >
            Back
          </button>
        </span>

        <OverlayTrigger
          overlay={
            isDisabled ? (
              <Tooltip id='tooltip-disabled'>
                Please complete all required fields
              </Tooltip>
            ) : (
              <></>
            )
          }
        >
          <span className='col-6 d-flex justify-content-center'>
            <button
              type='button'
              className='btn btn-primary mx-auto w-75 '
              onClick={() => changeStep("forward")}
              disabled={isDisabled}
            >
              Continue
            </button>
          </span>
        </OverlayTrigger>
      </div>
    </CardA>
  );
};

export default WizardSampleInfo;
